import { PropsWithChildren } from "react";
import { PageGrid, PageGridProps } from "src/components/layout/page-grid/deprecated/PageGrid";

/**
 * @deprecated Replaced by SenecPageGrid component
 *
 * PageGrid used to structure the content area of a page in the FPP (SENEC Cockpit).
 */
export const FPPPageGrid = (props: PropsWithChildren<PageGridProps>) => {
    return (
        <PageGrid
            maxContentWidth="1760px"
            columnSpacing={{ xs: 2, sm: 4 }}
            rowSpacing={{ xs: 2, sm: 4 }}
            paddingTop={5}
            paddingBottom={props.footer ? 5 : 10}
            {...props}
        />
    );
};
